import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // ✅ If App.jsx is in src folder (not pages)
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
